module.exports = __webpack_public_path__ + "img/Icon Analysts.103dbc00.svg";